module.exports = __webpack_public_path__ + "static/Compute-Software-Support-Services-c4cfebd1978a7b24c494bbf7571d2e37.pdf";